// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { informationLayoutStyles } from "@awc/App/Widgets/OrderDetails/OrderDetailsInformationLayout";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

informationLayoutStyles.wrapper = {
    css: css`
        display: flex;
        gap: 16px;
        & > div {
            flex-basis: 50%;
        }
        ${styledBoxStyle}
        ${xScreen("lte", "md")} {
            & > div {
                flex-basis: 100%;
            }
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
        @media print {
            flex-direction: row;
        }
    `,
};
